__turbopack_context__.v({
  "quoteLayoutWrapper": "A6XigG_quoteLayoutWrapper",
});
